<div class="cookie-popup" [class.cookie-popup__hidden] = hidden>
	<div class="cookie-popup__inner">
		<div class="cookie-popup__text">На сайте осуществляется обработка пользовательских данных с использованием Cookie в
			соответствии с <span>Условиями обработки пользовательских данных</span>. Вы можете запретить сохранение
			Cookie в настройках своего браузера</div>
		<button class="cookie-popup__button" (click)="hiddenPopup()">принять</button>
	</div>
</div>
